import { render, staticRenderFns } from "./LvoryBut.vue?vue&type=template&id=4bab5daa&scoped=true"
import script from "./LvoryBut.vue?vue&type=script&lang=js"
export * from "./LvoryBut.vue?vue&type=script&lang=js"
import style0 from "./LvoryBut.vue?vue&type=style&index=0&id=4bab5daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab5daa",
  null
  
)

export default component.exports